import { Component, OnInit, ViewChild, Output, EventEmitter, TemplateRef, Pipe } from '@angular/core';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { SimpleModalService } from 'ngx-simple-modal';
import { ConfirmComponent } from '../../confirm/confirm';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { Router, ActivatedRoute } from '@angular/router';
import { BillService } from 'src/app/_services/bill/bill.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SaleBillModel } from 'src/app/Entites/ExportToExcel/SaleBillModel';
import { TableexcelService } from 'src/app/_services/tableexcel.service';
import { DatePipe } from '@angular/common';
import { CommonConstants } from 'src/app/configuration/commonConstants';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
import { CommonService } from 'src/app/common/common.service';
import { LogMessages } from 'src/app/common/LogMessages';


@Component({
  selector: 'app-allbill',
  templateUrl: './allbill.component.html',
  styleUrls: ['./allbill.component.css'],
  providers: [CustomLoaderCComponent, ToastrService, DatePipe]
})
export class AllbillComponent implements OnInit {
  options = {
    close: false,
    expand: true,
    minimize: true,
    reload: false
  };
  columns: any = [];
  rows: any;
  name = 'Angular';
  model: any = {};
  value: any;
  loadingIndicator: true;
  selected = [];
  temp = [];
  temp2 = [];
  confirmResult = null;
  saleBillModel = new SaleBillModel();
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @ViewChild(DatatableComponent) table: DatatableComponent;
  UserTypeDescription: string;
  idLoggedInUser: number;
  public excelData = [];
  public DateFormat = CommonConstants.DateFormatString;
  public config: PerfectScrollbarConfigInterface = {};
  public breadcrumb: any;

  /**
     *
     * @param NgbModal      modal
     */
  constructor(
    private spinner: CustomLoaderCComponent,
    private modalpop: NgbModal,
    private toastrService: ToastrService,
    private router: ActivatedRoute,
    private routernav: Router,
    private SimpleModalService: SimpleModalService,
    private billService: BillService,
    private exportToexcelService: TableexcelService,
    private datePipe: DatePipe,
    private commonService: CommonService
  ) {
    this.UserTypeDescription = localStorage.getItem(LocalStorageConstants.USER_TYPE_DESCRIPTION);
  }

  ngOnInit() {

     if (!this.commonService.CheckUserAccess('all-bills', this.UserTypeDescription)) {
            console.warn(LogMessages.NO_ACCESS);
      this.routernav.navigate(['/dashboard/newdashboard']);
    }

    this.breadcrumb = {
      'mainlabel': 'All Sale Bills',
      'links': [
        {
          'name': 'New Invoice',
          'isLink': true,
          'link': '/bill/addbill'
        },
      ]
    };
    this.getallbill();
  }

  getallbill() {
    this.spinner.showSpinner();
    this.billService.GetAllBill().subscribe(Response => {
      this.rows = Response;
      this.temp2 = Response;
      this.temp = Response;
      this.spinner.hideSpinner();
    });
  }

  encrypt(id) {
    return btoa(id);
  }

  showConfirm(id) {
    this.SimpleModalService.addModal(ConfirmComponent, {
      title: 'Confirmation',
      message: 'Are you sure to delete this record ?'
    })
      .subscribe((isConfirmed) => {
        // Get modal result
        this.confirmResult = isConfirmed;

        if (isConfirmed) {
          this.spinner.showSpinner();
          this.billService.delete(id).subscribe(
            (res: any) => {
              if (res.result == 1) {
                this.ngOnInit();
                this.toastrService.success(res.userMessage, '', { timeOut: 1000, closeButton: true });
              }
              else {
                this.spinner.hideSpinner();
                this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
              }
            },
            err => {
              this.spinner.hideSpinner();
              this.toastrService.error('server is down', '', { timeOut: 3000, closeButton: true });
            }
          )
        }
      });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    this.rows = this.temp2; // and here you have to initialize it with your data
    this.temp = this.rows;
    // filter our data
    const temp = this.rows.filter(function (d) {
      return d.displayBillNumber.toLowerCase().indexOf(val) !== -1 ||
        d.customerFullName.toLowerCase().indexOf(val) !== -1 ||
        d.customerContact.toLowerCase().indexOf(val) !== -1 ||
        d.totalAmountIncGST == event.target.value ||
        d.totalpaidAmount == event.target.value ||
        d.balanceAmount == event.target.value ||
        d.totalAmountIncGST == event.target.value ||
        !val;
    });
    this.rows = temp;
  }

  GetExcelBillSalesData(): void {
    this.excelData = [];
    for (var i = 0; i < this.rows.length; i++) {
      this.saleBillModel = new SaleBillModel();
      this.saleBillModel.SrNo = i + 1;
      this.saleBillModel.BillDate = this.datePipe.transform(this.rows[i].billDate, CommonConstants.DateFormatString);
      this.saleBillModel.BillNo = this.rows[i].displayBillNumber;
      this.saleBillModel.CustomerName = this.rows[i].customerFullName;
      this.saleBillModel.ContactNumber = this.rows[i].customerContact;
      this.saleBillModel.TotalAmount = Math.round(this.rows[i].totalAmountIncGST);
      this.saleBillModel.BalanceAmount = Math.round(this.rows[i].balanceAmount);
      this.saleBillModel.BillType = this.rows[i].billType + (this.rows[i].isIgstBill ? " - IGST" : "");
      this.saleBillModel.PaidAmount = this.rows[i].totalpaidAmount;
      this.saleBillModel.Remark = this.rows[i].remark;
      this.excelData.push(this.saleBillModel);
    }
    this.exportToexcelService.exportAsExcelFile(this.excelData, "Sale-Bills-" + this.datePipe.transform(Date.now(), CommonConstants.DateFormatString));
  }
}
